import type { LucideIcon } from 'lucide-react';
import type { JSX } from 'react';

/**
 * The label+value tile shared by every stat grid in the app (Phase 8,
 * Pilar C). Extracted out of `my-student-summary-card.tsx`'s and
 * `progress-stats-grid.tsx`'s near-identical local copies once a third
 * caller needed the same icon+celebrate treatment - reuse, not a
 * speculative abstraction. `celebrate` only ever reflects a count the
 * caller already received, never a value computed in here.
 */
export function StatTile({
  label,
  value,
  icon: Icon,
  celebrate = false,
}: {
  readonly label: string;
  readonly value: string;
  readonly icon?: LucideIcon;
  readonly celebrate?: boolean;
}): JSX.Element {
  return (
    <div
      className={`flex flex-col gap-1 rounded-md border p-3 ${
        celebrate ? 'border-primary/30 bg-primary/5' : 'border-border'
      }`}
    >
      <span className="flex items-center gap-1.5 text-xs text-muted-foreground">
        {Icon !== undefined && <Icon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />}
        {label}
      </span>
      <span className="text-lg font-semibold">{value}</span>
    </div>
  );
}
